// Project.js
import { Container } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FabricsTable from "./FabricsTable";
import Header from "./Header";
import TicketsTable from "./TicketsTable";

const apiUrl = 'https://pyqx3pl5vlj4sycuxp3qat4bqi0oaqqh.lambda-url.ap-southeast-1.on.aws/project/'

const Project = () => {
  const { id } = useParams();
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setLoading(true);
        // Fetch specific project by ID
        const url = `${apiUrl}${id}`
        
        try {
          console.log("Fetching from URL:", url);
          
          const response = await fetch(url, {
            method: 'GET',
            // REMOVE no-cors mode - this is critical!
            headers: {
              'Content-Type': 'application/json'
            }
          });
          
          if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
          }
          
          const data = await response.json();
          console.log("API Response:", data);
          
          // Process the data
          if (data && data.data) {
            // Correctly map the response
            const ticketsData = data.data.find(item => item.result_type === 'tickets')?.results || [];
            const fabricsData = data.data.find(item => item.result_type === 'fabrics')?.results || [];
            const detailsData = data.data.find(item => item.result_type === 'details')?.results?.[0] || {};
            
            setProjectData({
              name: detailsData.project_name,
              client: detailsData.client_name,
              tickets: ticketsData,
              fabrics: fabricsData
            });
            
            if (detailsData.client_name) {
              document.title = detailsData.client_name;
            }
          } else {
            console.log("Data structure not as expected:", data);
            setError("Data structure not as expected");
          }
        } catch (error) {
          console.error("Error fetching project data:", error);
          setError(error.message);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  if (error) {
    return (
      <Box
        sx={{ width: "100%", maxWidth: 500, margin: "2rem", display: "flex" }}
      >
        <Typography variant="h5" component="h1" color="error" gutterBottom>
          Error: {error}
        </Typography>
      </Box>
    );
  }
  
  if (id && projectData) {
    return (
      <div>
        <Header
          projectName={projectData.name}
          clientName={projectData.client}
        />
        <Container>
          <TicketsTable projectData={projectData} />
        </Container>
        <Container>
          <FabricsTable projectData={projectData} />
        </Container>
      </div>
    );
  } else {
    return (
      <Box
        sx={{ width: "100%", maxWidth: 500, margin: "2rem", display: "flex" }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Unable to find project data
        </Typography>
      </Box>
    );
  }
};

export default Project;